import { render, staticRenderFns } from "./HomeEight.vue?vue&type=template&id=5371410a&scoped=true"
import script from "./HomeEight.vue?vue&type=script&lang=js"
export * from "./HomeEight.vue?vue&type=script&lang=js"
import style0 from "./HomeEight.vue?vue&type=style&index=0&id=5371410a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5371410a",
  null
  
)

export default component.exports